import {
    MessageBox
} from 'element-ui'

let CreatedOKLodop7766 = null

export function needCLodop() {
    try {
        let ua = navigator.userAgent
        if (ua.match(/Windows\sPhone/i) != null) return true
        if (ua.match(/iPhone|iPod/i) != null) return true
        if (ua.match(/Android/i) != null) return true
        if (ua.match(/Edge\D?\d+/i) != null) return true
        let verTrident = ua.match(/Trident\D?\d+/i)
        let verIE = ua.match(/MSIE\D?\d+/i)
        let verOPR = ua.match(/OPR\D?\d+/i)
        let verFF = ua.match(/Firefox\D?\d+/i)
        let x64 = ua.match(/x64/i)
        if (verTrident == null && verIE == null && x64 !== null) return true
        else if (verFF !== null) {
            verFF = verFF[0].match(/\d+/)
            if (verFF[0] >= 41 || x64 !== null) return true
        } else if (verOPR !== null) {
            verOPR = verOPR[0].match(/\d+/)
            if (verOPR[0] >= 32) return true
        } else if (verTrident == null && verIE == null) {
            let verChrome = ua.match(/Chrome\D?\d+/i)
            if (verChrome !== null) {
                verChrome = verChrome[0].match(/\d+/)
                if (verChrome[0] >= 41) return true
            }
        }
        return false
    } catch (err) {
        return true
    }
}

//====页面引用CLodop云打印必须的JS文件：====
if (needCLodop()) {
    let head =
        document.head ||
        document.getElementsByTagName('head')[0] ||
        document.documentElement
    let oscript = document.createElement('script')
    oscript.src = 'http://localhost:8000/CLodopfuncs.js?priority=1'
    head.insertBefore(oscript, head.firstChild)

    //引用双端口(8000和18000）避免其中某个被占用：
    oscript = document.createElement('script')
    oscript.src = 'http://localhost:18000/CLodopfuncs.js?priority=0'
    head.insertBefore(oscript, head.firstChild)
}

//====获取LODOP对象的主过程：http://www.lodop.net/download/Lodop6.226_Clodop3.092.zip====
export function getLodop(oOBJECT, oEMBED) {
    let strHtmInstall =
        "<br><font color='#999'>打印控件未安装!点击这里<a href='install_lodop32.exe' target='_self'>执行安装</a>,安装后请刷新页面或重新进入。</font>"
    let strHtmUpdate =
        "<br><font color='#999'>打印控件需要升级!点击这里<a href='install_lodop32.exe' target='_self'>执行升级</a>,升级后请重新进入。</font>"
    let strHtm64_Install =
        "<br><font color='#999'>打印控件未安装!点击这里<a href='install_lodop64.exe' target='_self'>执行安装</a>,安装后请刷新页面或重新进入。</font>"
    let strHtm64_Update =
        "<br><font color='#999'>打印控件需要升级!点击这里<a href='install_lodop64.exe' target='_self'>执行升级</a>,升级后请重新进入。</font>"
    let strHtmFireFox =
        "<br><br><font color='#999'>（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）</font>"
    let strHtmChrome =
        "<br><br><font color='#999'>(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）</font>"
    let strCLodopInstall =
        "<br><font color='#999'>CLodop云打印服务(localhost本地)未安装启动!点击这里<a href='http://www.mtsoftware.cn/download/Lodop6.226_Clodop4.127.zip' download target='_self'>执行安装</a>,安装后请刷新页面。</font>"
    let strCLodopUpdate =
        "<br><font color='#999'>CLodop云打印服务需升级!点击这里<a href='http://www.lodop.net/download/CLodop_Setup_for_Win32NT_https_3.083Extend.zip' download target='_self'>执行升级</a>,升级后请刷新页面。</font>"
    let LODOP
    try {
        let isIE =
            navigator.userAgent.indexOf('MSIE') >= 0 ||
            navigator.userAgent.indexOf('Trident') >= 0
        if (needCLodop()) {    /* 采用云打印 */
            try {
                LODOP = getCLodop()
            } catch (err) {}
            if (!LODOP && document.readyState !== 'complete') {
                // alert('C-Lodop没准备好，请稍后再试！')
                MessageBox.alert('C-Lodop没准备好，请稍后再试！', '提示', {});
                return
            }
            if (!LODOP) {
                MessageBox.alert(strCLodopInstall, '提示', {
                    dangerouslyUseHTMLString: true
                });
                return
            } else {
                if (CLODOP.CVERSION < '3.0.4.3') {
                    MessageBox.alert(strCLodopUpdate, '提示', {
                        dangerouslyUseHTMLString: true
                    });
                }
                if (oEMBED && oEMBED.parentNode)
                    oEMBED.parentNode.removeChild(oEMBED)
                if (oOBJECT && oOBJECT.parentNode)
                    oOBJECT.parentNode.removeChild(oOBJECT)
            }
        } else { /*非云打印模式*/
            let is64IE = isIE && navigator.userAgent.indexOf('x64') >= 0
            //=====如果页面有Lodop就直接使用，没有则新建:==========
            if (oOBJECT != undefined || oEMBED != undefined) {
                if (isIE) LODOP = oOBJECT
                else LODOP = oEMBED
            } else if (CreatedOKLodop7766 == null) {
                LODOP = document.createElement('object')
                LODOP.setAttribute('width', 0)
                LODOP.setAttribute('height', 0)
                LODOP.setAttribute(
                    'style',
                    'position:absolute;left:0px;top:-100px;width:0px;height:0px;',
                )
                if (isIE)
                    LODOP.setAttribute(
                        'classid',
                        'clsid:2105C259-1E0C-4534-8141-A753534CB4CA',
                    )
                else LODOP.setAttribute('type', 'application/x-print-lodop')
                document.documentElement.appendChild(LODOP)
                CreatedOKLodop7766 = LODOP
            } else LODOP = CreatedOKLodop7766
            //=====Lodop插件未安装时提示下载地址:==========
            if (LODOP == null || typeof LODOP.VERSION == 'undefined') {
                if (navigator.userAgent.indexOf('Chrome') >= 0)
                    MessageBox.alert('strHtmChrome', '提示', {});
                if (navigator.userAgent.indexOf('Firefox') >= 0)
                    MessageBox.alert('strHtmFireFox', '提示', {});
                if (is64IE) MessageBox.alert(strHtm64_Install, '提示', {dangerouslyUseHTMLString: true});
                else MessageBox.alert(strHtmInstall, '提示', {dangerouslyUseHTMLString: true});
                return LODOP
            }
        }
        if (LODOP.VERSION < '6.2.2.3') {
            if (!needCLodop()) {
                if (is64IE) MessageBox.alert(strHtm64_Update, '提示', {dangerouslyUseHTMLString: true});
                else if (isIE) MessageBox.alert(strHtmUpdate, '提示', {dangerouslyUseHTMLString: true});
                else
                    MessageBox.alert(strHtmUpdate, '提示', {dangerouslyUseHTMLString: true});
            }
            return LODOP
        }
        //===如下空白位置适合调用统一功能(如注册语句、语言选择等):===
        LODOP.SET_LICENSES("","EDDE5D3665AA10CBE5F26F60DFB8E72C","C94CEE276DB2187AE6B65D56B3FC2848","");
        //===========================================================
        return LODOP
    } catch (err) {
        alert('getLodop出错:' + err)
    }
}





// WEBPACK FOOTER //
// ./src/util/LodopFuncs.js